<mat-card class="card-formplayer"><!-- form-player.component.html -->
  <!-- common header -->
  <mat-card-header>
    <mat-card-title>
      {{ formTitle }}
      @if (authService.isTrainer() || authService.isManager() || authService.isAdministrator()) {
        <span class="show-trainer"
          >
          - {{ formOwnerName }}
        </span>
      }
    </mat-card-title>
    <mat-card-subtitle>
      {{ formDescription }}
    </mat-card-subtitle>
    <button class="cancel-btn" mat-button (click)="getBack()">
      <mat-icon class="shadow-cancel">clear</mat-icon>
    </button>
  </mat-card-header>
  <!-- For Version Google Form -->
  <mat-card-content>
    <div class="content">
      @for (item of formPlayerActivitiesTable; track item) {
        <div>
          @if (item.metadatas.typology.label === TypologyLabel.multipleChoiceUniqueAnswer) {
            <app-qcu [activityId]='item' [contextId]="assignmentId" [hideCorrection]="true" [disabled]="!canSave"></app-qcu>
          }
          @if (item.metadatas.typology.label === TypologyLabel.multipleChoice) {
            <app-qcm [activityId]='item' [contextId]="assignmentId" [hideCorrection]="true" [disabled]="!canSave"></app-qcm>
          }
          @if (item.metadatas.typology.label === TypologyLabel.trueFalse) {
            <app-true-false [activityId]='item'></app-true-false>
          }
          @if (item.metadatas.typology.label === TypologyLabel.shortAnswer) {
            <app-short-answer [activityId]='item' [contextId]="assignmentId" [hideCorrection]="true" [disabled]="!canSave"></app-short-answer>
          }
          @if (item.metadatas.typology.label === TypologyLabel.drawLine) {
            <app-draw-line [activityId]='item'></app-draw-line>
          }
          @if (item.metadatas.typology.label === TypologyLabel.sort) {
            <app-ordon [activityId]='item'></app-ordon>
          }
          @if (item.metadatas.typology.label === TypologyLabel.awareness) {
            <app-awareness [activityId]='item'></app-awareness>
          }
          @if (item.metadatas.typology.label === TypologyLabel.textMatching) {
            <app-text-matching [activityId]='item'></app-text-matching>
          }
          @if (item.metadatas.typology.label === TypologyLabel.pairing) {
            <app-appaire [activityId]='item'></app-appaire>
          }
          @if (item.metadatas.typology.label === TypologyLabel.fillBlanks) {
            <app-fill-in-blanks [activityId]='item'></app-fill-in-blanks>
          }
          @if (showFeedback) {
            <app-trainer-feedback [activity]="item" [contextId]="assignmentId" [displayMode]="formMode"></app-trainer-feedback>
          }
          @if (item.metadatas.typology.label === TypologyLabel.imageSoundZone) {
            <app-image-zoning-play-sound [activityId]='item' [contextId]="assignmentId"></app-image-zoning-play-sound>
          }
          @if (item.metadatas.typology.label === TypologyLabel.missing) {
            <app-what-is-missing [activityId]='item' [contextId]="assignmentId"></app-what-is-missing>
          }
          @if (item.metadatas.typology.label === TypologyLabel.recording) {
            <app-voice-recorder-activity [activityId]='item'></app-voice-recorder-activity>
          }
        </div>
      }
    </div>
  </mat-card-content>

  @if (formMode === 'feedback') {
    <textarea class="textareaContent" placeholder="{{ 'activities.form.comment' | translate }}" [(ngModel)]="overallActivitiesComments"></textarea>
  }
  @if (formMode === 'display') {
    <div class="textareaContent">{{ overallActivitiesComments }}</div>
  }

  <mat-card-actions>
    @if (canSave) {
      <button class="envoye-btn active" mat-button (click)="saveAnswers()">{{ 'generic.save' | translate }}</button>
    }
  </mat-card-actions>

</mat-card>
